export default "__VITE_ASSET__DyFOUlR6__"